const BELOW_ALL = -1;

const zIndexes = {
    BELOW_ALL,
    // base layers
    LAYER1: 10,
    LAYER2: 20,
    // intermediate layers
    EDITOR_STICKY_TOOLBAR: 30,
    HOVERED_STICKY_TOOLBAR: 32,
    EDITOR_SPELL_CHECKER_POPOVER: 34,
    EDITOR_COMMENTS: 36,
    EDITOR_FLOATING_TOOLBAR: 38,
    // top layers
    LAYER3: 100,
    FORM_LOADING_OVERLAY: 200,
    // above modal (MUI modal z-index is 1300)
    LAYER4: 1400,
};

export default zIndexes;
